<template>
  <div class="table-responsive mt-5">
    <div class="accordion" id="masterAccordion">
      <div
        v-for="(group, groupIndex) in masterData"
        :key="groupIndex"
        class="accordion-item"
      >
        <h2 class="accordion-header" :id="'heading' + groupIndex">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + groupIndex"
            aria-expanded="false"
            :aria-controls="'collapse' + groupIndex"
          >
            {{ getAccordionTitle(group) }}
          </button>
        </h2>
        <div
          :id="'collapse' + groupIndex"
          class="accordion-collapse collapse"
          :aria-labelledby="'heading' + groupIndex"
          data-bs-parent="#masterAccordion"
        >
          <div class="accordion-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th
                    v-for="column in getItemColumns(group, group._master_type)"
                    :key="column.key"
                  >
                    {{ column.label }}
                  </th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, itemIndex) in getPaginatedGroupItems(group)"
                  :key="itemIndex"
                >
                  <td
                    v-for="column in getItemColumns(item, group._master_type)"
                    :key="column.key"
                  >
                    <!-- 日付フィールドの特別フォーマット -->
                    <span
                      v-if="
                        [
                          'event_limit_startdate',
                          'event_limit_enddate'
                        ].includes(column.key)
                      "
                    >
                      {{ formatYmdDate(item[column.key]) }}
                    </span>
                    <span v-else>
                      {{ item[column.key] }}
                    </span>
                  </td>
                  <td>
                    <button
                      v-if="chk_relation_type_editable('/master/list')"
                      class="btn btn-sm btn-primary me-2"
                      @click="$emit('edit', item)"
                    >
                      編集
                    </button>
                    <button
                      v-if="chk_relation_type_editable('/master/list')"
                      class="btn btn-sm btn-danger"
                      @click="$emit('delete', item)"
                    >
                      削除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- グループごとのページネーション -->
            <nav v-if="getGroupTotalPages(group) > 1">
              <ul class="pagination">
                <li
                  class="page-item"
                  :class="{ disabled: group.currentPage === 1 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToGroupPage(group, group.currentPage - 1)"
                    >前</a
                  >
                </li>
                <li
                  class="page-item"
                  v-for="page in getGroupPagesToShow(group)"
                  :key="'group-' + groupIndex + '-page-' + page"
                  :class="{ active: group.currentPage === page }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToGroupPage(group, page)"
                    >{{ page }}</a
                  >
                </li>
                <li
                  class="page-item"
                  :class="{
                    disabled: group.currentPage === getGroupTotalPages(group)
                  }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToGroupPage(group, group.currentPage + 1)"
                    >次</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- データが存在しない場合のメッセージ -->
    <div
      v-if="masterData.length === 0 && isSearched"
      class="alert alert-warning mt-3"
    >
      <p>指定された条件に一致するデータが見つかりませんでした。</p>
    </div>
  </div>
</template>

<script>
import {
  getAccordionTitle,
  getItemColumns,
  formatYmdDate,
  COLUMN_MAPS
} from '@/utils/masterHelpers'

export default {
  name: 'MasterDataTable',
  props: {
    masterData: {
      type: Array,
      required: true
    },
    isSearched: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'delete'],
  methods: {
    getAccordionTitle(item) {
      return getAccordionTitle(item)
    },
    getItemColumns(item, fallbackMasterType = null) {
      const masterType = item._master_type || fallbackMasterType
      return COLUMN_MAPS[masterType] || []
    },
    formatYmdDate(val) {
      return formatYmdDate(val)
    },
    getPaginatedGroupItems(group) {
      const start = (group.currentPage - 1) * group.itemsPerPage
      const end = start + group.itemsPerPage
      return group.items.slice(start, end)
    },
    getGroupTotalPages(group) {
      return Math.ceil(group.items.length / group.itemsPerPage)
    },
    getGroupPagesToShow(group) {
      const totalPages = this.getGroupTotalPages(group)
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    },
    goToGroupPage(group, page) {
      const totalPages = this.getGroupTotalPages(group)
      if (page >= 1 && page <= totalPages) {
        group.currentPage = page
      }
    }
  }
}
</script>

<style scoped>
.accordion-button {
  background-color: #f8f9fa;
}
.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
}
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.pagination {
  justify-content: center;
  margin-top: 1rem;
}
</style>
